var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdf-hidden-sections-container" },
    _vm._l(_vm.sections, function(section) {
      return _c(
        "div",
        {
          key: section.name,
          staticClass: "section",
          class: [
            section.class,
            {
              "section--disabled": section.disabled,
              "section--not-disableable": !section.isDisableable
            }
          ],
          on: {
            click: function($event) {
              _vm.handleSectionClick(section)
            }
          }
        },
        [
          _c("q-tooltip", { attrs: { offset: [4, 4] } }, [
            _vm._v("\n      " + _vm._s(section.tooltip) + "\n    ")
          ])
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }